<template>
  <el-dialog class="approvalDialog" :title="$t('eventList.AppPro')" :visible.sync="dialogVisible" width="58%"
    @close="dialogCloseHandle">
    <div class="wrap">
      <div class="title">{{ $t('eventList.Fad') }}</div>
      <div class="container">
        <ul class="navTabs">
          <li v-for="(item, index) in processData" :key="index" :class="[
            { 'active': active === index },
            { 'stripe': index % 2 === 0 }
          ]" @click="deptBtn(index)">
            {{ item.deptName }}
          </li>
        </ul>
        <el-scrollbar class="approvalScrollbar">
          <div class="approvalContent">
            <div class="processTitle" v-if="verifyProcessData.length > 0">{{ $t('eventList.EAAF') }}</div>
            <commonProcess :process-data="activityProcessData" />
            <div class="processTitle" v-if="verifyProcessData.length > 0">{{ $t('eventList.AvAf') }}</div>
            <commonProcess :process-data="verifyProcessData" v-if="verifyProcessData.length > 0" />
          </div>
        </el-scrollbar>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import commonProcess from 'components/commonProcess';
import { activityQuery } from '../../service';
export default {
  data() {
    return {
      active: 0,
      dialogVisible: false,
      processData: [],
      activityProcessData: [],
      verifyProcessData: []
    };
  },
  props: {
    isReport: {
      type: Boolean,
      default: false
    },
    approvalDialogVisible: {
      type: Boolean,
      default: false
    },
    activityCode: {
      type: String,
      default: ''
    }
  },
  watch: {
    approvalDialogVisible(val) {
      if (val) {
        if (this.isReport) {
          this.getAllReportProcessHistory(this.activityCode);
        } else {
          this.getAllProcessHistory(this.activityCode);
        }
      } else {
        this.active = 0;
        this.processData = [];
        this.activityProcessData = [];
      }
      this.dialogVisible = val;
    }
  },
  components: {
    commonProcess
  },
  methods: {
    deptBtn (index) {
      this.activityProcessData = [];
      this.verifyProcessData = [];
      // 申请流程处理
      if (this.processData[index].processHistoryVO) {
        let data = this.processData[index].processHistoryVO;
        this.activityProcessData = data.mactFlowLogList.map(item => {
          return {
            title: item.node,
            details: item.reason,
            type: item.approveType,
            name: item.assigneeName,
            time: item.createTime,
            active: data.processState === 'completed'
          };
        });
        if (data.processState === 'completed') {
          this.activityProcessData = [
            ...this.activityProcessData,
            {
              name: this.$t('general.End'),
              active: true
            }
          ];
        }
      }
      if (this.processData[index].formLogDTOList) {
        let data = this.processData[index].formLogDTOList;
        this.verifyProcessData = data.map(item => {
          if (item.processState === 'completed') {
            return {
              name: this.$t('general.End'),
              active: true
            };
          }
          return {
            title: item.node,
            details: item.reason,
            type: item.approveType,
            name: item.assigneeName,
            time: item.time,
            active: item.processState === 'completed'
          };
        });
      }
      this.$nextTick(() => {
        let ele = document.querySelector('.approvalContent');
        ele.scrollTo(0, ele.scrollHeight);
      });
      this.active = index;
    },
    dialogCloseHandle() {
      this.$emit('dialogCloseHandle');
    },
    getAllReportProcessHistory(code) {
      activityQuery.getAllReportProcessHistory(code).then(res => {
        if (res.status === '200') {
          // 报备审批流程数据处理
          this.processData = res.data.map(item => {
            return {
              deptName: item.deptName,
              processHistoryVO: {
                processState: item.reportProcessHistoryVO.processState,
                mactFlowLogList: item.reportProcessHistoryVO.mactFlowLogReportList
              }
            };
          });
          // 默认展示第一个费用归属流程
          // 申请流程
          if (this.processData.length > 0 && this.processData[0].processHistoryVO) {
            let data = this.processData[0].processHistoryVO;
            this.activityProcessData = data.mactFlowLogList.map(item => {
              return {
                title: item.node,
                details: item.reason,
                type: item.approveType,
                name: item.assigneeName,
                time: item.createTime,
                active: data.processState === 'completed'
              };
            });
            if (data.processState === 'completed') {
              this.activityProcessData = [
                ...this.activityProcessData,
                {
                  name: this.$t('general.End'),
                  active: true
                }
              ];
            }
          }
          // 核销流程
          if (this.processData.length > 0 && this.processData[0].formLogDTOList) {
            let data = this.processData[0].formLogDTOList;
            this.verifyProcessData = data.map(item => {
              if (item.processState === 'completed') {
                return {
                  name: this.$t('general.End'),
                  active: true
                };
              }
              return {
                title: item.node,
                details: item.reason,
                type: item.approveType,
                name: item.assigneeName,
                time: item.time,
                active: item.processState === 'completed'
              };
            });
          }
          this.$nextTick(() => {
            let ele = document.querySelector('.approvalContent');
            ele.scrollTo(0, ele.scrollHeight);
          });
        }
      });
    },
    getAllProcessHistory(code) {
      activityQuery.getAllProcessHistory(code).then(res => {
        if (res.status === '200') {
          this.processData = res.data;
          console.log('processData', this.processData, res.data);
          // 默认展示第一个费用归属流程
          // 申请流程
          if (this.processData.length > 0 && this.processData[0].processHistoryVO) {
            let data = this.processData[0].processHistoryVO;
            this.activityProcessData = data.mactFlowLogList.map(item => {
              return {
                title: item.node,
                details: item.reason,
                type: item.approveType,
                name: item.assigneeName,
                time: item.createTime,
                active: data.processState === 'completed'
              };
            });
            if (data.processState === 'completed') {
              this.activityProcessData = [
                ...this.activityProcessData,
                {
                  name: this.$t('general.End'),
                  active: true
                }
              ];
            }
          }
          // 核销流程
          if (this.processData.length > 0 && this.processData[0].formLogDTOList) {
            let data = this.processData[0].formLogDTOList;
            this.verifyProcessData = data.map(item => {
              if (item.processState === 'completed') {
                return {
                  name: this.$t('general.End'),
                  active: true
                };
              }
              return {
                title: item.node,
                details: item.reason,
                type: item.approveType,
                name: item.assigneeName,
                time: item.time,
                active: item.processState === 'completed'
              };
            });
          }
          // 测试数据 前端不需要动 后端控制数据即可完成 与原流程一致
          this.$nextTick(() => {
            let ele = document.querySelector('.approvalContent');
            ele.scrollTo(0, ele.scrollHeight);
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/common";

.approvalDialog {
  .wrap {
    >.title {
      font-size: 16px;
      color: #313D4A;
      margin-bottom: 16px;
    }

    >.container {
      border: 1px solid #DEE1E7;
      display: flex;
      position: relative;

      >.navTabs {
        width: 130px;
        min-height: 500px;
        background: #FFFFFF;
        border-right: 1px solid #E2E4E9;

        &:before {
          content: '';
          display: block;
          width: 100%;
          height: 1px;
          background: #FFFFFF;
        }

        >li {
          padding: 16px 8px;
          line-height: 20px;
          color: #424C57;
          text-align: center;
          border-bottom: 1px solid #E2E4E9;
          cursor: pointer;
          font-size: 16px;
        }

        >.stripe {
          background: #F3F5F8;
        }

        >.active {
          background: #ecf6f5;
          color: #14937B;
        }
      }

      >.approvalScrollbar {
        position: absolute;
        left: 130px;
        right: 0;
        height: 100%;

        ::v-deep>.el-scrollbar__wrap {
          overflow-x: hidden;

          .approvalContent {
            padding: 0 40px;
            margin-top: 20px;

            >.processTitle {
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 16px;
              color: #14937B;
            }
          }
        }
      }
    }
  }
}
</style>
